/* eslint-disable */
import * as authActions from '../../../Store/Auth/Auth.types';
import { createActionTypeEvents } from '../Analytics.utils';

const actionTypeEvents = createActionTypeEvents(Object.values(authActions));

/**
 * The auth events
 * @param {func} metaDataFunc The metadata function
 * @returns {any} The analytics data
 */
const authEvents = (metaDataFunc) => ({
  ...actionTypeEvents(metaDataFunc),
  // AUTH_LOGIN_SUCCESS has a different event payload.
  [authActions.AUTH_LOGIN_SUCCESS]: ({ payload, type }) => {
    const { user } = payload;
    return {
      event: type,
      user,
    };
  },
});

export default authEvents;
